<template lang="pug">

    div

        //- Navigation
        navigation

        //- Content
        form.ui.form(v-on:submit.prevent="submit()")

            .ui.top.attached.header Benutzerinformation:
            .ui.bottom.attached.segment
                general-information-form(ref="generalInformationForm" v-model="model")

            .ui.top.attached.header Personendaten:
            .ui.bottom.attached.segment
                person-form(ref="personForm" v-model="model" v-bind:company-models="companies")

            div(v-show="companyId && canEditRoles")
                .ui.top.attached.header Rollen:
                .ui.bottom.attached.segment
                    role-form(ref="roleForm" v-bind:company-model="companyModel" v-model="model")

            .ui.bottom.secondary
                .ui.column.grid
                    .right.aligned.column
                        a.ui.labeled.icon.button(v-on:click='cancel()')
                            i.remove.icon
                            |  Abbrechen
                        button.ui.labeled.primary.icon.button
                            i.checkmark.icon
                            |  Speichern

</template>

<script>
    // import * as R from 'ramda'
    import store from '@/store'
    import GeneralInformationForm from '@/components/users/GeneralInformationForm.vue'
    import RoleForm from '@/components/users/RoleForm.vue'
    import PersonForm from '@/components/persons/Form.vue'
    import Navigation from '@/components/users/Navigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        components: { GeneralInformationForm, Navigation, PersonForm, RoleForm },

        beforeRouteEnter(to, from, next) {
            // Unternehmen PersonForm-Dropdown laden alle Seiten akkumuliert im Store
            store.dispatch('companies/loadPage', { size: 100 }).then(next)
        },

        computed: {

            canEditRoles() {
                return (this.$auth.roleIds || []).includes('ADMIN')
            },

            addresses() {
                return store.getters['addresses/all']
            },

            companyId() {
                return this.model.company
            },

            companyModel() {
                return store.getters['companies/byId'](this.companyId) || {}
            },

            companies() {
                return store.getters['companies/all']
            },

            isInvalid() {
                return this.$v.$invalid ||
                    this.$refs.generalInformationForm.$v.$invalid ||
                    this.$refs.personForm.$v.$invalid ||
                    this.$refs.roleForm.$v.$invalid
            }

        },

        data() {
            return {
                model: {},
            }
        },

        methods: {
            cancel() {
                this.$router.push({ name: 'users' })
            },

            submit() {
                this.validate().then(() => {
                    // Speichern
                    store.dispatch('users/create', { model: this.model })
                        .then(() => this.$growl.success('Benutzer wurde erstellt'))
                        .then(() => this.$router.push({ name: 'users' }))
                        .catch(e => this.$growl.fatal('Benutzer konnte nicht gespeichert werden. Bitte den Service kontaktieren', e))

                }).catch(() => this.$scrollToAndFocus('.field.error'))
            },

            validate() {
                const validators = [
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.personForm.validate(),
                ]

                if (this.canEditRoles) {
                    validators.push(this.$refs.roleForm.validate())
                }

                return Promise.all(validators)
            }

        },

    }

</script>
